import styled from "styled-components";
import { LockLarge } from "assets/svg";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const StyledIcon = styled(LockLarge)``;
